import { render } from "./BedBathDropdown.vue?vue&type=template&id=5fd361c6"
import script from "./BedBathDropdown.vue?vue&type=script&lang=js"
export * from "./BedBathDropdown.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__